import { type ForwardedRef, forwardRef } from 'react';

import { EmployeeHiringSource } from '@/common/graphql';
import { ObjectUtils } from '@/common/utils';

import type { ComboboxItemWithFormatted } from '../props';
import { SelectSingle, type SelectSingleProps } from '../SelectSingle';

interface EmployeeHiringSourceSelectSingleProps
  extends Omit<SelectSingleProps<ComboboxItemWithFormatted<EmployeeHiringSource>>, 'searchable' | 'value'> {
  value: EmployeeHiringSource | null;
}

export const EmployeeHiringSourceLabels: Record<EmployeeHiringSource, string> = {
  [EmployeeHiringSource.Agency]: 'Agency',
  [EmployeeHiringSource.CompanyWebsite]: 'Company Website',
  [EmployeeHiringSource.JobPosting]: 'Job Posting',
  [EmployeeHiringSource.Referral]: 'Referral',
  [EmployeeHiringSource.SocialMedia]: 'Social Media',
  [EmployeeHiringSource.Sourcing]: 'Sourcing',
};

const data = ObjectUtils.arrayFromEnumValues<EmployeeHiringSource>(EmployeeHiringSource).map(value => ({
  label: EmployeeHiringSourceLabels[value],
  value,
}));

export const EmployeeHiringSourceSelectSingle = forwardRef(
  (
    { placeholder = 'Select Hiring source', ...rest }: EmployeeHiringSourceSelectSingleProps,
    ref: ForwardedRef<HTMLDivElement>,
  ) => (
    <SelectSingle
      ref={ref}
      {...rest}
      data={data}
      loading={false}
      maxItemVisible={data.length}
      placeholder={placeholder}
    />
  ),
);
